// Roof Master tile — the grid Robert lives in (Ship 3, Aug 26 2026).
//
// A link tile, but not a dead one: it carries the live row count of the grid it
// opens, using the SAME stage list `RoofMasterTable` queries so the number on
// the tile is the number of rows on the page. If that list ever changes, change
// it in both places (or the tile starts lying).

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../../../lib/supabase";
import { logCardClick } from "../../../lib/uiEvents";

// Mirror of RoofMasterTable's `masterStages`.
const MASTER_STAGES = [
  "assign_roof_specialist",
  "pre_inspection_ready",
  "pre_inspection_complete",
  "adjuster_meeting_ready",
  "adjuster_meeting_scheduled",
  "waiting_on_claims",
  "partial_approval",
  "docs_and_contingency",
  "reinspection_ready",
  "reinspection_filed",
  "schedule_build",
  "build_scheduled",
  "build_submitted",
  "install_meeting",
];

export default function RoofMasterWidget() {
  const [n, setN] = useState<number | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { count, error } = await supabase
        .from("deals")
        .select("id", { count: "exact", head: true })
        .in("stage", MASTER_STAGES);
      if (cancelled) return;
      if (error) setFailed(true);
      else setN(count ?? 0);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Link
      to="/roof-master"
      onClick={() => logCardClick("widget_roofmaster_open")}
      className="block rounded-2xl border border-slate-200 bg-white p-4 hover:border-bardin-orange transition-colors"
    >
      <div className="flex items-center gap-2 mb-1">
        <span>📋</span>
        <span className="font-bold text-sm text-bardin-ink">Roof Master</span>
        <span className="ml-auto text-xs font-bold text-slate-500">
          {failed ? "—" : n == null ? "…" : `${n} jobs`}
        </span>
      </div>
      <div className="text-[11.5px] text-slate-500 leading-snug">
        Every live claim and build in one editable grid — your saved views, columns and custom
        fields.
      </div>
      <div className="text-[11px] font-bold text-bardin-orange mt-2">Open the grid ›</div>
    </Link>
  );
}
